<template>
	<div>
		<!--===================== EDITING =====================-->
		<div v-if = "editing" >
			<div class = "mb-3">
				<button class = "btn btn-md btn-gradient-danger mr-2"  @click = "cancel">Cancel</button>
				<button class = "btn btn-md btn-gradient-success"  @click = "editSubmit">Update</button>
			</div>
			<table class = "table table-bordered">
				<tbody>
					<!-- <tr>
						<th>
							Fulfilment Modes
						</th>
						<td>
							<div style = "display: inline-block;" v-for = "m in fulfilmentModes" @click = "addFulfilmentMode(m)">
								<button class = "btn btn-md btn-gradient-success mr-2" v-if = "editForm['Fulfilment Modes'].includes(m)">{{m}}</button>
								<button class = "btn btn-md btn-gradient-danger mr-2" v-else>{{m}}</button>
							</div>
							<p class = "font-red">{{errorMsg["Fulfilment Modes"]}}</p>
						</td>
					</tr> -->
					<!-- <tr>
						<th>
							Tax
						</th>
						<td>
							<input type="number" class = "form-control" v-model = "editForm['Tax']">
							<p class = "font-red">{{errorMsg["Tax"]}}</p>
						</td>
					</tr> -->
					<!-- f -->
				</tbody>
			</table>
			<div v-if = "editForm['Fulfilment Modes'].includes('Dine In')" class = "mt-3">
				<h3>Dine In Information</h3>
				<table class="table table-bordered">
					<!-- <tr>
						<th>Service Charge</th>
						<td>
							<input type="number" v-model = "editForm['Dine In Tax']" class= "form-control">	
							<p class = "font-red" v-if = "errorMsg['Dine In Tax']">{{errorMsg['Dine In Tax']}}</p>	
						</td>
					</tr> -->
					<tr>
						<th>
							Opening Hours
							<button @click = "setSameTime('DI')">Set Same Time as Pickup</button>
						</th>
						<td>
							<table class="table table-bordered">
								<tr v-for=  "day in weekdays">
									<th>
										{{day}}
									</th>
									<td>
										<table class = "table table-bordered">
											<button class = "btn btn-sm btn-gradient-primary"  @click = "addElement('DI' + day)">Add</button>
											<tr>
												<th>Start</th>
												<th>End</th>
												<th>Pax per Slot</th>
												<th> Actions </th>
											</tr>
											<tr v-for = "(element,elementIndex) in editForm['DI' + day]">
												<td>
													<input type = "time" class = "form-control" placeholder = "10:08" v-model = "editForm['DI' + day][elementIndex]['Start']">
													<p class = "font-red">{{errorMsg["DI" + day][elementIndex]["Start"]}}</p>
												</td>
												<td>
													<input type = "time" class = "form-control" placeholder = "10:08" v-model = "editForm['DI' + day][elementIndex]['End']">
													<p class = "font-red">{{errorMsg["DI" + day][elementIndex]["End"]}}</p>
												</td>
												<td>
													<input type = "number" class = "form-control" placeholder = "Pax per Slot" v-model = "editForm['DI' + day][elementIndex]['Pax per Slot']">
													<p class = "font-red">{{errorMsg["DI" + day][elementIndex]["Pax per Slot"]}}</p>
												</td>
												<td>
													<button class = "btn btn-sm btn-gradient-danger"  @click = "removeElem('DI' + day, elementIndex)">Delete</button>
												</td>
											</tr>
										</table>

									</td>
								</tr>
							</table>
						</td>
					</tr>
				</table>
			</div>
			<div v-if = "editForm['Fulfilment Modes'].includes('Delivery')" class = "mt-3">
				<h3>Delivery Information</h3>
				<table class="table table-bordered">
					<!-- <tr>
						<th>
							Delivery Mode(s)
						</th>
						<td>
							<div style = "display: inline-block;" v-for = "m in delModes" @click = "addDeliveryMode(m);">
								<button class = "btn btn-md btn-gradient-success mr-2" v-if = "editForm['Delivery Modes'].includes(m)">{{m}}</button>
								<button class = "btn btn-md btn-gradient-danger mr-2" v-else>{{m}}</button>
							</div>
							<p class = "font-red">{{errorMsg["Delivery Mode"]}}</p>
						</td>
					</tr> -->
					<!-- <tr>
						<th>
							Occam Delivery Partners
						</th>
						<td>
							<div style = "display: inline-block;" v-for = "doc in deliveryPartners">
								<div style = "display: inline-block;" v-for = "(m, mIndex) in doc.DeliveryServicePartners" @click = "addOccamDelivery(mIndex);">
									<button class = "btn btn-md btn-gradient-success mr-2" v-if = "editForm['Occam Delivery Partners'].includes(mIndex)">{{m.Name}}</button>
									<button class = "btn btn-md btn-gradient-danger mr-2" v-else>{{m.Name}}</button>
								</div>
							</div>
							<p class = "font-red">{{errorMsg["Occam Delivery Partners"]}}</p>
						</td>
					</tr> -->
					<tr>
						<th>
							Opening Times
							<button @click = "setSameTime('d')">Set Same Time as Pickup</button>
						</th>
						<td>
							<table class="table table-bordered">
								<tr v-for = "day in weekdays">
									<th>
										{{day}}
									</th>
									<td>
										<button class = "btn btn-sm btn-gradient-primary mb-2"  @click = "addElement('d' + day)" v-if = "editForm['d' + day].length>0">Add</button>
										<button class = "btn btn-sm btn-gradient-primary mb-2"  @click = "addElement('d' + day)" v-else>Open</button>
										<table class = "table-bordered table" v-if = "editForm['d' + day].length>0">
											<tr>
												<th>Start</th>
												<th>End</th>
												<th> Actions </th>
											</tr>
											<tr v-for = "(element,elementIndex) in editForm['d' + day]">
												<td>
													<input type = "time" class = "form-control" placeholder = "10:08" v-model = "editForm['d' + day][elementIndex]['Start']">
													<p class = "font-red">{{errorMsg['d' + day][elementIndex]["Start"]}}</p>
												</td>
												<td>
													<input type = "time" class = "form-control" placeholder = "10:08" v-model = "editForm['d' + day][elementIndex]['End']">
													<p class = "font-red">{{errorMsg['d' + day][elementIndex]["End"]}}</p>
												</td>
												<td>
													<button class = "btn btn-sm btn-gradient-danger"  @click = "removeElem('d' + day, elementIndex)">Delete</button>
												</td>
											</tr>
										</table>
										<p v-else>Closed</p>
									</td>
								</tr>
							</table>
						</td>
					</tr>
					<tr>
						<th>
							Hours Ahead
						</th>
						<td>
							<input type = "number" class = "form-control" placeholder = "Hours Ahead" v-model = "editForm['dHours Ahead']">
							<p class = "font-red">{{errorMsg["dHours Ahead"]}}</p>
						</td>
					</tr>
					<tr>
						<th>
							Days Ahead
						</th>
						<td>
							<table class = "table table-bordered">
								<tr>
									<th>Minimum</th>
									<th>Maximum</th>
								</tr>
								<tr>
									<td>
										<input type = "number" class = "form-control" placeholder = "Minimum" v-model = "editForm['dDays Ahead']['Minimum']">
										<p class = "font-red">{{errorMsg["dDays Ahead"]["Minimum"]}}</p>
									</td>
									<td>
										<input type = "number" class = "form-control" placeholder = "Maximum" v-model = "editForm['dDays Ahead']['Maximum']">
										<p class = "font-red">{{errorMsg["dDays Ahead"]["Maximum"]}}</p>
									</td>
								</tr>

							</table>
						</td>
					</tr>
					<tr>
						<th>
							Delivery Fee
						</th>
						<td>
							<input type="number" class = "form-control" v-model = "editForm['Delivery Fee']">
							<p class = "font-red">{{errorMsg["Delivery Fee"]}}</p>
						</td>
					</tr>
					<tr>
						<th>
							Delivery Rate (per km)
						</th>
						<td>
							<input type="number" class = "form-control" v-model = "editForm['Delivery Rate']">
							<p class = "font-red">{{errorMsg["Delivery Rate"]}}</p>
						</td>
					</tr>
					<tr>
						<th>
							Delivery Message
						</th>
						<td>
							<textarea class = "form-control" v-model = "editForm['Delivery Message']"></textarea>
							<p class = "font-red">{{errorMsg["Delivery Message"]}}</p>
						</td>
					</tr>
					<tr v-if = "oriItem['Delivery Modes'].includes('Own Team')">
						<th>
							Delivery Distance (km)
						</th>
						<td>
							<table class="table table-bordered">
								<tr>
									<th>Minimum (Base price is capped at this distance)</th>
									<td>
										<input type="number" class = "form-control" v-model = "editForm['Min Delivery Distance']">
										<p class = "font-red">{{errorMsg["Min Delivery Distance"]}}</p>
									</td>
								</tr>
								<tr>
									<th>Maximum</th>
									<td>
										<input type="number" class = "form-control" v-model = "editForm['Max Delivery Distance']">
										<p class = "font-red">{{errorMsg["Max Delivery Distance"]}}</p>
									</td>
								</tr>
							</table>
						</td>
					</tr>
					<tr>
						<th>
							Minimum Order (For Checkout)
						</th>
						<td>
							<input type="number" class = "form-control" v-model = "editForm['Minimum Order Checkout']">
							<p class = "font-red">{{errorMsg["Minimum Order Checkout"]}}</p>
						</td>
					</tr>
					<tr>
						<th>
							Minimum Order (For Reduced Delivery Fee))
						</th>
						<td>
							<input type="number" class = "form-control" v-model = "editForm['Minimum Order']">
							<p class = "font-red">{{errorMsg["Minimum Order"]}}</p>
						</td>
					</tr>
					<tr>
						<th>
							Deduction Amount
						</th>
						<td>
							<input type = "number" class = "form-control" v-model = "editForm['Deduction Amount']">
							<p class = "font-red">{{errorMsg["Deduction Amount"]}}</p>
						</td>
					</tr>
					<tr>
						<th>
							Delivery Contact Name
						</th>
						<td>
							<input type = "text" class = "form-control" v-model = "editForm['Delivery Contact Name']">
							<p class = "font-red">{{errorMsg["Delivery Contact Name"]}}</p>
						</td>
					</tr>
					<tr>
						<th>
							Delivery Contact Number
						</th>
						<td>
							<input type = "text" class = "form-control" v-model = "editForm['Delivery Contact Number']">
							<p class = "font-red">{{errorMsg["Delivery Contact Number"]}}</p>
						</td>
					</tr>
				</table>
			</div>
			<div v-if = "editForm['Fulfilment Modes'].includes('Pickup')" class = "mt-3">
				<h3>Pickup Information</h3>
				<table class="table table-bordered" >
					<tbody>
						<tr>
							<th>
								Hours Ahead
							</th>
							<td>
								<input type = "number" class = "form-control" placeholder = "Hours Ahead" v-model = "editForm['Hours Ahead']">
								<p class = "font-red">{{errorMsg["Hours Ahead"]}}</p>
							</td>
						</tr>
						<tr>
							<th>
								Days Ahead
							</th>
							<td>
								<table class = "table table-bordered">
									<tr>
										<th>Minimum</th>
										<th>Maximum</th>
									</tr>
									<tr>
										<td>
											<input type = "number" class = "form-control" placeholder = "Minimum" v-model = "editForm['Days Ahead']['Minimum']">
											<p class = "font-red">{{errorMsg["Days Ahead"]["Minimum"]}}</p>
										</td>
										<td>
											<input type = "number" class = "form-control" placeholder = "Maximum" v-model = "editForm['Days Ahead']['Maximum']">
											<p class = "font-red">{{errorMsg["Days Ahead"]["Maximum"]}}</p>
										</td>
									</tr>

								</table>
							</td>
						</tr>
						<tr>
							<th>
								Minimum Order for Checkout (Pickup)
							</th>
							<td>
								<input type = "number" class = "form-control" placeholder = "pMinimum Order" v-model = "editForm['pMinimum Order']">
								<p class = "font-red">{{errorMsg["pMinimum Order"]}}</p>
							</td>
						</tr>
					<tr>
						<th>
							Opening Times
							<div class="mt-1"></div>
							<select class = "form-control" v-model = "editForm['timeZone']">
								<option :value="t" v-for = "t in timeZones">{{t}}</option>
							</select>
						</th>
						<td>
							<table class="table table-bordered">
								<tr v-for = "day in weekdays">
									<th>
										{{day}}
									</th>
									<td>
										<button class = "btn btn-sm btn-gradient-primary mb-2"  @click = "addElement(day)" v-if = "editForm[day].length>0">Add</button>
										<button class = "btn btn-sm btn-gradient-primary mb-2"  @click = "addElement(day)" v-else>Open</button>
										<table class = "table-bordered table" v-if = "editForm[day].length>0">
											<tr>
												<th>Start</th>
												<th>End</th>
												<th> Actions </th>
											</tr>
											<tr v-for = "(element,elementIndex) in editForm[day]">
												<td>
													<input type = "time" class = "form-control" placeholder = "10:08" v-model = "editForm[day][elementIndex]['Start']">
													<p class = "font-red">{{errorMsg[day][elementIndex]["Start"]}}</p>
												</td>
												<td>
													<input type = "time" class = "form-control" placeholder = "10:08" v-model = "editForm[day][elementIndex]['End']">
													<p class = "font-red">{{errorMsg[day][elementIndex]["End"]}}</p>
												</td>
												<td>
													<button class = "btn btn-sm btn-gradient-danger"  @click = "removeElem(day, elementIndex)">Delete</button>
												</td>
											</tr>
										</table>
										<p v-else>Closed</p>
									</td>
								</tr>
							</table>
						</td>
					</tr>
					</tbody>
				</table>
			</div>
			<div class = "mt-3">
				<button class = "btn btn-md btn-gradient-danger mr-2"  @click = "cancel">Cancel</button>
				<button class = "btn btn-md btn-gradient-success"  @click = "editSubmit">Update</button>
			</div>
		</div>

		<!--===================== VIEWING =====================-->
		<div v-else-if = "loaded">
			<!-- <div class = "mb-3">
				<button class = "btn btn-md btn-gradient-info"  @click = "editStart(oriItem, oriItem['.key'])">Edit</button>
			</div> -->
			<table class = "table table-bordered">
				<tbody>
					<tr>
						<th>
							Fulfilment Modes
						</th>
						<td>
							<span v-for = "(m, mIndex) in oriItem['Fulfilment Modes']">
								{{m}}
								<span v-if = "mIndex < oriItem['Fulfilment Modes'].length -1">, </span>
							</span>
						</td>
					</tr>
					<!-- <tr>
						<th>
							Tax
						</th>
						<td>
							{{oriItem["Tax"]}} %
						</td>
					</tr>
					<tr>
						<th>
							Booking Fee
						</th>
						<td>
							{{formatPrice(oriItem["Booking Fee"] || 0, "RM")}}
						</td>
					</tr> -->
				</tbody>
			</table>
			<div v-if = "oriItem['Fulfilment Modes'].includes('Dine In')" class = "mt-3">
				<h3>Dine In Information</h3>
				<table class="table table-bordered">
					<tr>
						<th>Service Charge</th>
						<td>
							{{oriItem['Dine In Tax'] || 0}} %
						</td>
					</tr>
					<tr>
						<th>Opening Hours</th>
						<td>
							<table class="table table-bordered">
								<tr v-for = "day in weekdays">
									<th>
										{{day}}
									</th>
									<td>
										<div v-for = "time in oriItem['DI' + day]">{{showTime(time.Start + "-" + time.End)}} ({{time["Pax per Slot"]}})</div>
									</td>
								</tr>
							</table>
						</td>
					</tr>
				</table>
			</div>
			<div v-if = "oriItem['Fulfilment Modes'].includes('Delivery')" class = "mt-3">
				<h3>Delivery Information</h3>
				<table class="table table-bordered">
					<tr>
						<th>
							Enabled Delivery Mode(s)
						</th>
						<td>
							<span v-for = "(d, dIndex) in oriItem['Delivery Modes']">{{d}}<span v-if = "dIndex < oriItem['Delivery Modes'].length-1">, </span></span>
						</td>
					</tr>
					<tr>
						<th>
							Opening Times ({{oriItem.timeZone || "UTC+08:00"}})
						</th>
						<td>
							<table class = "table table-bordered">
								<tr v-for = "day in weekdays">
									<th>
										{{day}}
									</th>
									<td>
										<div v-for = "t in (oriItem['d' + day] || '').split(',')">{{showTime(t)}}</div>
									</td>
								</tr>
							</table>
						</td>
					</tr>
					<tr>
						<th>
							Hours Ahead
						</th>
						<td>
							{{oriItem["dHours Ahead"]}}
						</td>
					</tr>
					<tr>
						<th>
							Days Ahead
						</th>
						<td>
							<table class = "table table-bordered">

								<tr>
									<th>Minimum</th>
									<th>Maximum</th>
								</tr>
								<tr>
									<td>
										{{oriItem['dDays Ahead']['Minimum']}}
									</td>
									<td>
										{{oriItem['dDays Ahead']['Maximum']}}
									</td>
								</tr>

							</table>
						</td>
					</tr>
					<tr>
						<th>
							Delivery Fee
						</th>
						<td>
							{{formatPrice(oriItem['Delivery Fee'] || 0, "RM")}}
						</td>
					</tr>
					<tr v-if = "oriItem['Delivery Modes'].includes('Own Team')">
						<th>
							Delivery Rate (per km)
						</th>
						<td>
							{{formatPrice(oriItem['Delivery Rate'] || 0, "RM")}}
						</td>
					</tr>
					<tr v-if = "oriItem['Delivery Modes'].includes('Own Team')">
						<th>
							Delivery Distance (km)
						</th>
						<td>
							<table class="table table-bordered">
								<tr>
									<th>Minimum (Base price is capped at this distance)</th>
									<td>
										{{oriItem['Min Delivery Distance']}}
									</td>
								</tr>
								<tr>
									<th>Maximum</th>
									<td>
										{{oriItem['Max Delivery Distance']}}
									</td>
								</tr>
							</table>
						</td>
					</tr>
					<tr>
						<th>
							Minimum Order (For Checkout)
						</th>
						<td>
							{{formatPrice(oriItem['Minimum Order Checkout'] || 0, "RM")}}
						</td>
					</tr>
					<tr>
						<th>
							Minimum Order (For Reduced Delivery Fee)
						</th>
						<td>
							{{formatPrice(oriItem['Minimum Order'] || 0, "RM")}}
						</td>
					</tr>
					<tr>
						<th>
							Deduction Amount
						</th>
						<td>
							{{formatPrice(oriItem['Deduction Amount'] || 0, "RM")}}
						</td>
					</tr>
					<tr>
						<tr>
							<th>
								Delivery Message
							</th>
							<td>
								<textarea readonly name="" id="" cols="30" rows="10" class = "form-control">{{oriItem['Delivery Message']}}</textarea>
							</td>
						</tr>
						<th>
							Delivery Contact Name
						</th>
						<td>
							{{oriItem['Delivery Contact Name']}}
						</td>
					</tr>
					<tr>
						<th>
							Delivery Contact Number
						</th>
						<td>
							{{oriItem['Delivery Contact Number']}}
						</td>
					</tr>
				</table>
			</div>
			<div v-if = "oriItem['Fulfilment Modes'].includes('Pickup')" class = "mt-3">
				<h3>Pickup Information</h3>
				<table class="table table-bordered" >
					<tbody>
						<tr>
							<th>
								Hours Ahead
							</th>
							<td>
								{{oriItem["Hours Ahead"]}}
							</td>
						</tr>
						<tr>
							<th>
								Days Ahead
							</th>
							<td>
								<table class = "table table-bordered">

									<tr>
										<th>Minimum</th>
										<th>Maximum</th>
									</tr>
									<tr>
										<td>
											{{oriItem['Days Ahead']['Minimum']}}
										</td>
										<td>
											{{oriItem['Days Ahead']['Maximum']}}
										</td>
									</tr>

								</table>
							</td>
						</tr>
						<tr>
							<th>
								Minimum Order for Checkout (Pickup)
							</th>
							<td>
								{{formatPrice(oriItem["pMinimum Order"] || 0, "RM")}}
							</td>
						</tr>
						<tr>
							<th>
								Opening Times ({{oriItem.timeZone || "UTC+08:00"}})
							</th>
							<td>
								<table class = "table table-bordered">
									<tr v-for = "day in weekdays">
										<th>
											{{day}}
										</th>
										<td>
											<div v-for = "t in oriItem[day].split(',')">{{showTime(t)}}</div>
										</td>
									</tr>
								</table>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
	</div>
</template>


<script>
import imageCompression from 'browser-image-compression';
import XLSX from "xlsx";
var md5 = require('md5');
var uuid = require('uuid/v5');
var dbPath = "settings";
var docID = "preorderSetting";
var itemTemplate;
export default {
	//==============================================//
	//												//
	//					DATA						//
	//												//
	//==============================================//
	data(){
		itemTemplate = [{"Name":"dMonday","checkFun":"multi-time","children":[{"Name":"Start","checkFun":"time","defaultValue":"08:00","inputType":"time","manyView":false,"max":"11:59","min":"00:00","placeholder":"10:08","singleView":false,"type":"Time"},{"Name":"End","checkFun":"time","defaultValue":"20:00","inputType":"time","manyView":false,"max":"11:59","min":"00:00","placeholder":"10:08","singleView":false,"type":"Time"}],"defaultValue":"","inputType":"time","manyView":true,"max":"","min":"","placeholder":"Array","singleView":true,"type":"MultiTime"},{"Name":"dTuesday","checkFun":"multi-time","children":[{"Name":"Start","checkFun":"time","defaultValue":"08:00","inputType":"time","manyView":false,"max":"11:59","min":"00:00","placeholder":"10:08","singleView":false,"type":"Time"},{"Name":"End","checkFun":"time","defaultValue":"20:00","inputType":"time","manyView":false,"max":"11:59","min":"00:00","placeholder":"10:08","singleView":false,"type":"Time"}],"defaultValue":"","inputType":"time","manyView":true,"max":"","min":"","placeholder":"Array","singleView":true,"type":"MultiTime"},{"Name":"dWednesday","checkFun":"multi-time","children":[{"Name":"Start","checkFun":"time","defaultValue":"08:00","inputType":"time","manyView":false,"max":"11:59","min":"00:00","placeholder":"10:08","singleView":false,"type":"Time"},{"Name":"End","checkFun":"time","defaultValue":"20:00","inputType":"time","manyView":false,"max":"11:59","min":"00:00","placeholder":"10:08","singleView":false,"type":"Time"}],"defaultValue":"","inputType":"time","manyView":true,"max":"","min":"","placeholder":"Array","singleView":true,"type":"MultiTime"},{"Name":"dThursday","checkFun":"multi-time","children":[{"Name":"Start","checkFun":"time","defaultValue":"08:00","inputType":"time","manyView":false,"max":"11:59","min":"00:00","placeholder":"10:08","singleView":false,"type":"Time"},{"Name":"End","checkFun":"time","defaultValue":"20:00","inputType":"time","manyView":false,"max":"11:59","min":"00:00","placeholder":"10:08","singleView":false,"type":"Time"}],"defaultValue":"","inputType":"time","manyView":true,"max":"","min":"","placeholder":"Array","singleView":true,"type":"MultiTime"},{"Name":"dFriday","checkFun":"multi-time","children":[{"Name":"Start","checkFun":"time","defaultValue":"08:00","inputType":"time","manyView":false,"max":"11:59","min":"00:00","placeholder":"10:08","singleView":false,"type":"Time"},{"Name":"End","checkFun":"time","defaultValue":"20:00","inputType":"time","manyView":false,"max":"11:59","min":"00:00","placeholder":"10:08","singleView":false,"type":"Time"}],"defaultValue":"","inputType":"time","manyView":true,"max":"","min":"","placeholder":"Array","singleView":true,"type":"MultiTime"},{"Name":"dSaturday","checkFun":"multi-time","children":[{"Name":"Start","checkFun":"time","defaultValue":"08:00","inputType":"time","manyView":false,"max":"11:59","min":"00:00","placeholder":"10:08","singleView":false,"type":"Time"},{"Name":"End","checkFun":"time","defaultValue":"20:00","inputType":"time","manyView":false,"max":"11:59","min":"00:00","placeholder":"10:08","singleView":false,"type":"Time"}],"defaultValue":"","inputType":"time","manyView":true,"max":"","min":"","placeholder":"Array","singleView":true,"type":"MultiTime"},{"Name":"dSunday","checkFun":"multi-time","children":[{"Name":"Start","checkFun":"time","defaultValue":"08:00","inputType":"time","manyView":false,"max":"11:59","min":"00:00","placeholder":"10:08","singleView":false,"type":"Time"},{"Name":"End","checkFun":"time","defaultValue":"20:00","inputType":"time","manyView":false,"max":"11:59","min":"00:00","placeholder":"10:08","singleView":false,"type":"Time"}],"defaultValue":"","inputType":"time","manyView":true,"max":"","min":"","placeholder":"Array","singleView":true,"type":"MultiTime"}, {"Name":"dHours Ahead","checkFun":"nonNeg","children":[],"defaultValue":"0","inputType":"number","manyView":true,"max":"Inf","min":"-Inf","placeholder":"dHours Ahead","singleView":true,"type":"Price"}, {"Name":"dDays Ahead","checkFun":"none","children":[{"Name":"Minimum","checkFun":"nonNeg","children":[],"defaultValue":"0","inputType":"number","manyView":true,"max":"Inf","min":"-Inf","placeholder":"Price","singleView":true,"type":"Price"},{"Name":"Maximum","checkFun":"posNum","children":[],"defaultValue":"0","inputType":"number","manyView":true,"max":"Inf","min":"-Inf","placeholder":"Price","singleView":true,"type":"Price"}],"defaultValue":"","inputType":"text","manyView":true,"max":"","min":"","placeholder":"dDays Ahead","singleView":true,"type":"JSON"}, {"Name":"Days Ahead","checkFun":"none","children":[{"Name":"Minimum","checkFun":"nonNeg","children":[],"defaultValue":"0","inputType":"number","manyView":true,"max":"Inf","min":"-Inf","placeholder":"Price","singleView":true,"type":"Price"},{"Name":"Maximum","checkFun":"posNum","children":[],"defaultValue":"0","inputType":"number","manyView":true,"max":"Inf","min":"-Inf","placeholder":"Price","singleView":true,"type":"Price"}],"defaultValue":"","inputType":"text","manyView":true,"max":"","min":"","placeholder":"Days Ahead","singleView":true,"type":"JSON"},{"Name":"Sunday","checkFun":"multi-time","children":[{"Name":"Start","checkFun":"time","defaultValue":"08:00","inputType":"time","manyView":false,"max":"11:59","min":"00:00","placeholder":"10:08","singleView":false,"type":"Time"},{"Name":"End","checkFun":"time","defaultValue":"20:00","inputType":"time","manyView":false,"max":"11:59","min":"00:00","placeholder":"10:08","singleView":false,"type":"Time"}],"defaultValue":"","inputType":"time","manyView":true,"max":"","min":"","placeholder":"Sunday","singleView":true,"type":"MultiTime"},{"Name":"Monday","checkFun":"multi-time","children":[{"Name":"Start","checkFun":"time","defaultValue":"08:00","inputType":"time","manyView":false,"max":"11:59","min":"00:00","placeholder":"10:08","singleView":false,"type":"Time"},{"Name":"End","checkFun":"time","defaultValue":"20:00","inputType":"time","manyView":false,"max":"11:59","min":"00:00","placeholder":"10:08","singleView":false,"type":"Time"}],"defaultValue":"","inputType":"time","manyView":true,"max":"","min":"","placeholder":"Monday","singleView":true,"type":"MultiTime"},{"Name":"Tuesday","checkFun":"multi-time","children":[{"Name":"Start","checkFun":"time","defaultValue":"08:00","inputType":"time","manyView":false,"max":"11:59","min":"00:00","placeholder":"10:08","singleView":false,"type":"Time"},{"Name":"End","checkFun":"time","defaultValue":"20:00","inputType":"time","manyView":false,"max":"11:59","min":"00:00","placeholder":"10:08","singleView":false,"type":"Time"}],"defaultValue":"","inputType":"time","manyView":true,"max":"","min":"","placeholder":"Tuesday","singleView":true,"type":"MultiTime"},{"Name":"Wednesday","checkFun":"multi-time","children":[{"Name":"Start","checkFun":"time","defaultValue":"08:00","inputType":"time","manyView":false,"max":"11:59","min":"00:00","placeholder":"10:08","singleView":false,"type":"Time"},{"Name":"End","checkFun":"time","defaultValue":"20:00","inputType":"time","manyView":false,"max":"11:59","min":"00:00","placeholder":"10:08","singleView":false,"type":"Time"}],"defaultValue":"","inputType":"time","manyView":true,"max":"","min":"","placeholder":"Wednesday","singleView":true,"type":"MultiTime"},{"Name":"Thursday","checkFun":"multi-time","children":[{"Name":"Start","checkFun":"time","defaultValue":"08:00","inputType":"time","manyView":false,"max":"11:59","min":"00:00","placeholder":"10:08","singleView":false,"type":"Time"},{"Name":"End","checkFun":"time","defaultValue":"20:00","inputType":"time","manyView":false,"max":"11:59","min":"00:00","placeholder":"10:08","singleView":false,"type":"Time"}],"defaultValue":"","inputType":"time","manyView":true,"max":"","min":"","placeholder":"Thursday","singleView":true,"type":"MultiTime"},{"Name":"Friday","checkFun":"multi-time","children":[{"Name":"Start","checkFun":"time","defaultValue":"08:00","inputType":"time","manyView":false,"max":"11:59","min":"00:00","placeholder":"10:08","singleView":false,"type":"Time"},{"Name":"End","checkFun":"time","defaultValue":"20:00","inputType":"time","manyView":false,"max":"11:59","min":"00:00","placeholder":"10:08","singleView":false,"type":"Time"}],"defaultValue":"","inputType":"time","manyView":true,"max":"","min":"","placeholder":"Friday","singleView":true,"type":"MultiTime"},{"Name":"Saturday","checkFun":"multi-time","children":[{"Name":"Start","checkFun":"time","defaultValue":"08:00","inputType":"time","manyView":false,"max":"11:59","min":"00:00","placeholder":"10:08","singleView":false,"type":"Time"},{"Name":"End","checkFun":"time","defaultValue":"20:00","inputType":"time","manyView":false,"max":"11:59","min":"00:00","placeholder":"10:08","singleView":false,"type":"Time"}],"defaultValue":"","inputType":"time","manyView":true,"max":"","min":"","placeholder":"Saturday","singleView":true,"type":"MultiTime"},{"Name":"Hours Ahead","checkFun":"posNum","children":[],"defaultValue":"0","inputType":"number","manyView":true,"max":"Inf","min":"-Inf","placeholder":"Hours Ahead","singleView":true,"type":"Price"},{"Name":"Fulfilment Modes","checkFun":"none","children":[],"defaultValue":"0","inputType":"number","manyView":true,"max":"Inf","min":"-Inf","placeholder":"Fulfilment Mode","singleView":true,"type":"Price"},{"Name":"Delivery Fee","checkFun":"nonNeg","children":[],"defaultValue":"0","inputType":"number","manyView":true,"max":"Inf","min":"-Inf","placeholder":"Delivery Fee","singleView":true,"type":"Price"},{"Name":"Minimum Order","checkFun":"nonNeg","children":[],"defaultValue":"0","inputType":"number","manyView":true,"max":"Inf","min":"-Inf","placeholder":"Minimum Order","singleView":true,"type":"Price"},{"Name":"Minimum Order Checkout","checkFun":"nonNeg","children":[],"defaultValue":"0","inputType":"number","manyView":true,"max":"Inf","min":"-Inf","placeholder":"Minimum Order Checkout","singleView":true,"type":"Price"},{"Name":"Deduction Amount","checkFun":"nonNeg","children":[],"defaultValue":"0","inputType":"number","manyView":true,"max":"Inf","min":"-Inf","placeholder":"Deduction Amount","singleView":true,"type":"Price"}, {"Name":"Delivery Contact Name","checkFun":"none","children":[],"defaultValue":"","inputType":"text","manyView":true,"max":"","min":"","placeholder":"Name","singleView":true,"type":"Name"}, {"Name":"Delivery Contact Number","checkFun":"none","children":[],"defaultValue":"","inputType":"text","manyView":true,"max":"","min":"","placeholder":"Name","singleView":true,"type":"Name"}, {"Name":"Delivery Mode","checkFun":"none","children":[],"defaultValue":"","inputType":"text","manyView":true,"max":"","min":"","placeholder":"Name","singleView":true,"type":"Name"},{"Name":"Tax","checkFun":"nonNeg","children":[],"defaultValue":"0","inputType":"number","manyView":true,"max":"Inf","min":"-Inf","placeholder":"Tax","singleView":true,"type":"Price"},{"Name":"Minimum Order","checkFun":"nonNeg","children":[],"defaultValue":"0","inputType":"number","manyView":true,"max":"Inf","min":"-Inf","placeholder":"Minimum Order","singleView":true,"type":"Price"},{"Name":"Min Delivery Distance","checkFun":"nonNeg","children":[],"defaultValue":"0","inputType":"number","manyView":true,"max":"Inf","min":"-Inf","placeholder":"Min Delivery Distance","singleView":true,"type":"Price"},{"Name":"Max Delivery Distance","checkFun":"nonNeg","children":[],"defaultValue":"0","inputType":"number","manyView":true,"max":"Inf","min":"-Inf","placeholder":"Max Delivery Distance","singleView":true,"type":"Price"},{"Name":"Minimum Order","checkFun":"nonNeg","children":[],"defaultValue":"0","inputType":"number","manyView":true,"max":"Inf","min":"-Inf","placeholder":"Minimum Order","singleView":true,"type":"Price"},{"Name":"pMinimum Order","checkFun":"nonNeg","children":[],"defaultValue":"0","inputType":"number","manyView":true,"max":"Inf","min":"-Inf","placeholder":"pMinimum Order","singleView":true,"type":"Price"},{"Name":"Booking Fee","checkFun":"nonNeg","children":[],"defaultValue":"0","inputType":"number","manyView":true,"max":"Inf","min":"-Inf","placeholder":"Booking Fee","singleView":true,"type":"Price"},{"Name":"timeZone","checkFun":"text","children":[],"defaultValue":"0","inputType":"number","manyView":true,"max":"Inf","min":"-Inf","placeholder":"timeZone","singleView":true,"type":"text"},{"Name":"DISunday","checkFun":"none","children":[{"Name":"Start","checkFun":"time","children":[],"defaultValue":"08:00","inputType":"time","manyView":true,"max":"11:59","min":"00:00","placeholder":"10:08","singleView":true,"type":"Time"},{"Name":"End","checkFun":"time","children":[],"defaultValue":"08:00","inputType":"time","manyView":true,"max":"11:59","min":"00:00","placeholder":"10:08","singleView":true,"type":"Time"},{"Name":"Pax per Slot","checkFun":"posNum","children":[],"defaultValue":"0","inputType":"number","manyView":true,"max":"Inf","min":"-Inf","placeholder":"Price","singleView":true,"type":"Price"}],"defaultValue":"","inputType":"text","manyView":true,"max":"","min":"","placeholder":"Array","singleView":true,"type":"Array"},{"Name":"DIMonday","checkFun":"none","children":[{"Name":"Start","checkFun":"time","children":[],"defaultValue":"08:00","inputType":"time","manyView":true,"max":"11:59","min":"00:00","placeholder":"10:08","singleView":true,"type":"Time"},{"Name":"End","checkFun":"time","children":[],"defaultValue":"08:00","inputType":"time","manyView":true,"max":"11:59","min":"00:00","placeholder":"10:08","singleView":true,"type":"Time"},{"Name":"Pax per Slot","checkFun":"posNum","children":[],"defaultValue":"0","inputType":"number","manyView":true,"max":"Inf","min":"-Inf","placeholder":"Price","singleView":true,"type":"Price"}],"defaultValue":"","inputType":"text","manyView":true,"max":"","min":"","placeholder":"Array","singleView":true,"type":"Array"},{"Name":"DITuesday","checkFun":"none","children":[{"Name":"Start","checkFun":"time","children":[],"defaultValue":"08:00","inputType":"time","manyView":true,"max":"11:59","min":"00:00","placeholder":"10:08","singleView":true,"type":"Time"},{"Name":"End","checkFun":"time","children":[],"defaultValue":"08:00","inputType":"time","manyView":true,"max":"11:59","min":"00:00","placeholder":"10:08","singleView":true,"type":"Time"},{"Name":"Pax per Slot","checkFun":"posNum","children":[],"defaultValue":"0","inputType":"number","manyView":true,"max":"Inf","min":"-Inf","placeholder":"Price","singleView":true,"type":"Price"}],"defaultValue":"","inputType":"text","manyView":true,"max":"","min":"","placeholder":"Array","singleView":true,"type":"Array"},{"Name":"DIWednesday","checkFun":"none","children":[{"Name":"Start","checkFun":"time","children":[],"defaultValue":"08:00","inputType":"time","manyView":true,"max":"11:59","min":"00:00","placeholder":"10:08","singleView":true,"type":"Time"},{"Name":"End","checkFun":"time","children":[],"defaultValue":"08:00","inputType":"time","manyView":true,"max":"11:59","min":"00:00","placeholder":"10:08","singleView":true,"type":"Time"},{"Name":"Pax per Slot","checkFun":"posNum","children":[],"defaultValue":"0","inputType":"number","manyView":true,"max":"Inf","min":"-Inf","placeholder":"Price","singleView":true,"type":"Price"}],"defaultValue":"","inputType":"text","manyView":true,"max":"","min":"","placeholder":"Array","singleView":true,"type":"Array"},{"Name":"DIThursday","checkFun":"none","children":[{"Name":"Start","checkFun":"time","children":[],"defaultValue":"08:00","inputType":"time","manyView":true,"max":"11:59","min":"00:00","placeholder":"10:08","singleView":true,"type":"Time"},{"Name":"End","checkFun":"time","children":[],"defaultValue":"08:00","inputType":"time","manyView":true,"max":"11:59","min":"00:00","placeholder":"10:08","singleView":true,"type":"Time"},{"Name":"Pax per Slot","checkFun":"posNum","children":[],"defaultValue":"0","inputType":"number","manyView":true,"max":"Inf","min":"-Inf","placeholder":"Price","singleView":true,"type":"Price"}],"defaultValue":"","inputType":"text","manyView":true,"max":"","min":"","placeholder":"Array","singleView":true,"type":"Array"},{"Name":"DIFriday","checkFun":"none","children":[{"Name":"Start","checkFun":"time","children":[],"defaultValue":"08:00","inputType":"time","manyView":true,"max":"11:59","min":"00:00","placeholder":"10:08","singleView":true,"type":"Time"},{"Name":"End","checkFun":"time","children":[],"defaultValue":"08:00","inputType":"time","manyView":true,"max":"11:59","min":"00:00","placeholder":"10:08","singleView":true,"type":"Time"},{"Name":"Pax per Slot","checkFun":"posNum","children":[],"defaultValue":"0","inputType":"number","manyView":true,"max":"Inf","min":"-Inf","placeholder":"Price","singleView":true,"type":"Price"}],"defaultValue":"","inputType":"text","manyView":true,"max":"","min":"","placeholder":"Array","singleView":true,"type":"Array"},{"Name":"DISaturday","checkFun":"none","children":[{"Name":"Start","checkFun":"time","children":[],"defaultValue":"08:00","inputType":"time","manyView":true,"max":"11:59","min":"00:00","placeholder":"10:08","singleView":true,"type":"Time"},{"Name":"End","checkFun":"time","children":[],"defaultValue":"08:00","inputType":"time","manyView":true,"max":"11:59","min":"00:00","placeholder":"10:08","singleView":true,"type":"Time"},{"Name":"Pax per Slot","checkFun":"posNum","children":[],"defaultValue":"0","inputType":"number","manyView":true,"max":"Inf","min":"-Inf","placeholder":"Price","singleView":true,"type":"Price"}],"defaultValue":"","inputType":"text","manyView":true,"max":"","min":"","placeholder":"Array","singleView":true,"type":"Array"},{"Name":"Dine In Tax","checkFun":"nonNeg","children":[],"defaultValue":"0","inputType":"number","manyView":true,"max":"Inf","min":"-Inf","placeholder":"Price","singleView":true,"type":"Price"},];
		return{
			// FORM
			addForm: {},
			editForm: {},
			viewForm: {},
			errorMsg: {},

			// NAV VARIABLES
			editing: false,
			loaded: true,

			// PLACEHOLDER
			oriItem: this.$parent.preOrderSetting,
			weekdays: myDate.weekdays,
			fulfilmentModes: ["Dine In", "Delivery", "Pickup"],
			delModes: ["MrSpeedy", "GoGet", "Mula", "LalaMove", "Own Team"],
			deliveryPartners: [],
			timeZones: ["UTC−12:00","UTC−11:00","UTC−10:00","UTC−09:30","UTC−09:00","UTC−08:00","UTC−07:00","UTC−06:00","UTC−05:00","UTC−04:00","UTC−03:30","UTC−03:00","UTC−02:00","UTC−01:00","UTC+00:00","UTC+01:00","UTC+02:00","UTC+03:00","UTC+03:30","UTC+04:00","UTC+04:30","UTC+05:00","UTC+05:30","UTC+05:45","UTC+06:00","UTC+06:30","UTC+07:00","UTC+08:00","UTC+08:45","UTC+09:00","UTC+09:30","UTC+10:00","UTC+10:30","UTC+11:00","UTC+12:00","UTC+12:45","UTC+13:00","UTC+14:00"]
		}
	},

	firestore(){
		dbPath = "business/" + this.$route.params.businessID + "/settings";
		docID = "preOrderSetting";
		var coords = this.$parent.$parent.storeSetting.coords;
		this.$binding("deliveryPartners", myFB.getCol("settings/allDelPartners/all").orderBy("Date Created")).then(r=>{});
	},
	watch:{
		"$parent.preOrderSetting"(){
			this.oriItem = this.$parent.preOrderSetting;
		}
	},

	//==============================================//
	//												//
	//					METHODS						//
	//												//
	//==============================================//
	methods:{
		setSameTime(type){
			this.weekdays.forEach(day=>{
				var timeNow = myCopier.copy(this.editForm[day]);
				timeNow["Pax per Slot"] = "0";
				this.editForm[type + day] = timeNow
				this.errorMsg[type + day] = myCopier.copyAs(timeNow, "");
			})
		},
		//---------------------------- DELIVERY ------------------------------//
		addFulfilmentMode(m){
			if (this.editForm["Fulfilment Modes"].includes(m)){
				this.editForm["Fulfilment Modes"].splice(this.editForm["Fulfilment Modes"].indexOf(m), 1);
			}
			else{
				this.editForm["Fulfilment Modes"].push(m);
			}
		},
		addDeliveryMode(m){
			if (this.editForm["Delivery Modes"].includes(m)){
				this.editForm["Delivery Modes"].splice(this.editForm["Delivery Modes"].indexOf(m), 1);
			}
			else{
				this.editForm["Delivery Modes"].push(m);
			}
		},
		addOccamDelivery(m){
			if (this.editForm["Occam Delivery Partners"].includes(m)){
				this.editForm["Occam Delivery Partners"].splice(this.editForm["Occam Delivery Partners"].indexOf(m), 1);
			}
			else{
				this.editForm["Occam Delivery Partners"].push(m);
			}
		},
		occamDelIncluded(modes, m){
			var found = false;
			modes.forEach((r, index)=>{
				if (r.ID === m.ID){
					found = true;
				}
			})
			return found;
		},
		//------------------------------ PHOTO -------------------------------//
		async setPhoto(e, item, ID){
			let fileList = e.target.files || e.dataTransfer.file;

			if (item.Photo != undefined && item.Photo != ''){
				myFB.storage.ref(dbPath + "/" + ID).delete();
			}

			const options = { 
				maxSizeMB: 0.1,          
				maxWidthOrHeight: 300,   
			}
			const compressedFile = await imageCompression(fileList[0], options);
			console.log('compressedFile instanceof Blob', compressedFile instanceof Blob);
			console.log(`compressedFile size ${compressedFile.size / 1024 } KB`);
			var update = {};
			update["Photo"] =  await this.uploadFile(compressedFile,dbPath + "/" + ID)

			myFB.updateDoc(dbPath, update, docID, this, "Updating photo...", "Photo updated!");        
		},
		async uploadFile(f, path){
			var fileURL = "";

			console.log("Uploading to " + path);
			await myFB.storage.ref(path).put(f).then(async r=>{
				await r.ref.getDownloadURL().then(async url=>{
					fileURL = url;
				})
			});
			return fileURL;
		},
		//------------------------------ FORMAT ------------------------------//
		formatDate(input){
			var mode = {
				sequence: "d m y",
				monthMode: 2,
			}
			return myDate.displayDate(input, mode);
		},
		formatDateTime(input){
			var mode = {
				sequence: "d m y",
				monthMode: 2,
			}
			return myDate.displayDateTime(input, mode, {sequence: "hh:mm"});
		},
		formatPrice(input, prefix){
			var prefix = prefix || "";
			return myPrice.display(input, prefix)
		},
		showTime(t){
			if (!t){
				return "Closed";
			}
			var output = "";
			var d = new Date();
			d.setHours(t.substring(0,2));
			d.setMinutes(t.substring(3,5));

			output = myDate.displayTime(d.getTime(),{
				sequence: "hh:mm",
				hourFormat: 12
			});

			d.setHours(t.substring(6,8));
			d.setMinutes(t.substring(9,11));

			output += " - " + myDate.displayTime(d.getTime(),{
				sequence: "hh:mm",
				hourFormat: 12
			});

			return output;
		},
		//------------------------------ UPDATE ------------------------------//
		editStart(item, ID){
			var editForm = myCopier.copy(item);
			delete editForm[".key"];
			var response = myInput.editMain(editForm, itemTemplate);
			response.output["Delivery Modes"] = myCopier.copy(item["Delivery Modes"]) || [];
			response.output["Occam Delivery Partners"] = myCopier.copy(item["Occam Delivery Partners"]) || [];
			this.errorMsg = response.errorMsg;
			this.editForm = response.output;
			this.editForm["timeZone"] = response.output.timeZone || "UTC+08:00";
			this.editForm["Fulfilment Modes"] = response.output["Fulfilment Modes"] || [];
			this.editing = true;
		},
		editSubmit(){
			var response;
			var allowAdd = true;
			var checkFun = itemTemplate, editForm = myCopier.copy(this.editForm);
			response = myInput.checkMain(editForm, checkFun);
			this.errorMsg = response.errorMsg;
			if (response.error){
				allowAdd = false;
			}
			console.log(this.errorMsg)
			if (editForm["Fulfilment Modes"].includes("Delivery")){
				if (editForm["Delivery Message"] == undefined || editForm["Delivery Message"] == ""){
					allowAdd = false;
					this.errorMsg["Delivery Message"] = "Value is empty."
				}
				if (editForm["Delivery Contact Number"] == undefined || editForm["Delivery Contact Number"] == ""){
					allowAdd = false;
					this.errorMsg["Delivery Contact Number"] = "Value is empty."
				}
				else if (isNaN(editForm["Delivery Contact Number"].replace("+","").replace(/ /g, ""))){
					allowAdd = false;
					this.errorMsg["Delivery Contact Number"] = "Value can only be numbers.";
				}
				if (editForm["Delivery Modes"].length<=0 && editForm["Occam Delivery Partners"].length<=0){
					allowAdd = false;
					this.errorMsg["Delivery Mode"] = "Please choose at least one delivery service."
				}
				else if (editForm["Delivery Modes"].includes("Own Team") ){
					if (editForm["Delivery Fee"] == "" || editForm["Delivery Fee"] == undefined){
						allowAdd = false;
						this.errorMsg["Delivery Fee"] = "Value is empty."	
					}
					if (editForm["Delivery Rate"] == "" || editForm["Delivery Rate"] == undefined){
						allowAdd = false;
						this.errorMsg["Delivery Rate"] = "Value is empty."	
					}
					if (editForm["Max Delivery Distance"] == "" || editForm["Max Delivery Distance"] == undefined){
						allowAdd = false;
						this.errorMsg["Max Delivery Distance"] = "Value is empty."
					}
					if (editForm["Min Delivery Distance"] == "" || editForm["Min Delivery Distance"] == undefined){
						allowAdd = false;
						this.errorMsg["Max Delivery Distance"] = "Value is empty."
					}
				}
			}
			if (allowAdd){
				var minStart, minEnd, minNow, hourNow, date = new Date(), timeNow, index;
				this.weekdays.forEach(day=>{
					response.output["DIs" + day] = {};
					response.output["DI" + day].forEach(s=>{
						minStart = parseInt(s.Start.substring(0,2))*60 + parseInt(s.Start.substring(3,5));
						minEnd = parseInt(s.End.substring(0,2))*60 + parseInt(s.End.substring(3,5));
						for (index = 0; index <= (minEnd - minStart)/30; index++){
							minNow = minStart + index*30;
							hourNow = Math.floor(minNow/60).toString();

							date.setHours(0);
							date.setMinutes(0);
							date.setSeconds(0);
							date.setMinutes(minNow);

							minNow = minNow%60;

							if (hourNow < 10){
								hourNow = "0" + hourNow;
							}
							if (minNow < 10){
								minNow = "0" + minNow;
							}

							timeNow = hourNow + ":" + minNow;
							response.output["DIs" + day][timeNow] = s["Pax per Slot"];
						}
					})
				})
				myFB.updateDoc(dbPath, response.output, docID, this, "Updating " + docID + "..." , docID + " updated!");
				myFB.updateDoc("business", {"Delivery Modes": response.output["Delivery Modes"], "Occam Partners": response.output["Occam Delivery Partners"]}, this.$route.params.businessID);
				this.cancel();
			}
		},
		//----------------------------- BACK -----------------------------//
		cancel(){
			this.viewing = false;
			this.adding = false;
			this.editing = false;
			this.sorting = false;
		},
		addElement(elementName, elementIndex){
			var temp;
			itemTemplate.forEach(r=>{
				if (r.Name == elementName){
					temp = r.children;
				}
			})
			var newElement = myInput.init(temp);
			if (this.adding){
				this.errorMsg[elementName].push(newElement.errorMsg);
				this.addForm[elementName].push(newElement.output);
			}
			else{
				this.errorMsg[elementName].push(newElement.errorMsg);
				this.editForm[elementName].push(newElement.output);
			}
		},
		removeElem(elementName, elementIndex){
			this.editForm[elementName].splice(elementIndex, 1);
			this.errorMsg[elementName].splice(elementIndex, 1);
		}
	}
};
</script>


// WEBPACK FOOTER //
// src/components/Manager/StoreSetting.vue